import React, { useEffect, useState, useContext } from "react";
import "./AddCircleGetApi.css";
import { AddCircleContext } from "../../contexts/AddCircleContext";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DeleteModal from "../modals/DeleteModal.";
import apiUrl from "../../utils/ApiConfig";

export default function AddCircleGetApi() {
  const [resobj, setResObj] = useState("");
  const circleContext2 = useContext(AddCircleContext);
  const [deletFlag, setDeletFlag] = useState(false);
  const [isShowDeletModal, setIsShowDeletModal] = useState(false);
  const [id, setId] = useState(""); //<<==prop to send id of every td of table to deletModal

  /////////////////////////////
  const cancelModalHandler = () => {
    setIsShowDeletModal(false);
  };
  ///////////////////////////
  const editHandler = (w) => {
    let g = resobj.filter((item) => item[1].ID === w);
    circleContext2.setAddCirFlag2(true);
    circleContext2.setAddCirFlag3(true);
    circleContext2.setAddCirFlag4((prev) => !prev);
    circleContext2.setAddCirFlag5((prev) => !prev);
    circleContext2.setSrcToApiPut([g[0][1]]);
  };
  /////////////////////////////////
  const deletHandler = (w) => {
    async function myAppDelet() {
      const response = await fetch(
        `${apiUrl}/api/Dayerehs/{id}?id=${w}`,
        {
          method: "DELETE",
        }
      ).then((response) => setDeletFlag((prev) => !prev));
    }
    myAppDelet();
    setIsShowDeletModal(false);
  };
  ////////////////////////////////
  useEffect(() => {
    async function myApp() {
      const response = await fetch(
        `${apiUrl}/api/Dayerehs`,
        {
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setResObj(Object.entries(data));
          Object.entries(data);
        });
    }
    myApp();
  }, [circleContext2.addCirFlag, deletFlag]);

  ////////////////////////////////
  return (
    <div className="addcirgetapi-container">
      <table className="table table-striped">
        <thead>
          <tr className="table-warning">
            <th scope="col">#</th>
            <th scope="col">تصویر</th>
            <th scope="col">نام دایره</th>
            <th scope="col">آخرین تغییر</th>
            <th scope="col">ویرایش/حذف </th>
          </tr>
        </thead>
        <tbody>
          {resobj &&
            resobj.map((item, index) => (
              <tr
                className="addcirgetapi-tableimg-tr"
                id={item[1].ID}
                key={item[1].ID}
              >
                <th
                  style={{ backgroundColor: "inherit", border: "none" }}
                  scope="row"
                >
                  {index + 1}
                </th>
                <td className=" yyy">
                  <div className="addcirgetapi-tableimg-div">
                    {item[1].Order.split(",").map((src) => (
                      <div className="xxxx">
                        <img
                          className="addcirgetapi-tableimg-img"
                          src={src}
                          alt=""
                        />
                      </div>
                    ))}
                  </div>{" "}
                </td>
                <td>{item[1].Name} </td>
                <td> {item[1].LastModified}</td>
                <td>
                  <div className="addcirgetapi-tableimg-div-icon">
                    <div
                      onClick={() => {
                        editHandler(item[1].ID);
                        setId(item[1].ID);
                        circleContext2.setIdToApiPut(item[1].ID);
                        circleContext2.setAddCirFlag5((prev) => !prev);
                      }}
                    >
                      <BorderColorIcon className="addcirgetapi-tableimg-icon-edit" />
                    </div>
                    <div
                      onClick={() => {
                        setId(item[1].ID);
                        setIsShowDeletModal(true);
                      }}
                    >
                      <DeleteForeverIcon className="addcirgetapi-tableimg-icon-delet" />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {isShowDeletModal && (
        <DeleteModal
          showModal={cancelModalHandler}
          deleteApiHandler={() => deletHandler(id)}
        />
      )}
    </div>
  );
}
